module.exports = "<p>\n  page-not-found works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/claudio/Projects/thebatclaudio.github.io/src/app/page-not-found/page-not-found.component.html
// module id = ../../../../../src/app/page-not-found/page-not-found.component.html
// module chunks = main